// Class ability + universal move reference for the Dossier's "Class ability"
// panel. Values MUST mirror backend/src/game/mobfight/mobfight.combat.ts
// exactly — verified against ABILITY and resolveRound() on 2026-07-10.
import type { HeroClass } from './hero-api';

export interface ClassAbilityInfo {
  name: string;
  cooldown: number; // rounds until ready again
  desc: string;
}

/** Class signature move — mirrors mobfight.combat.ts:ABILITY. */
export const CLASS_ABILITY: Record<HeroClass, ClassAbilityInfo> = {
  WARRIOR: { name: 'Haymaker', cooldown: 3, desc: 'A guaranteed crushing blow — ×2.2 damage.' },
  PALADIN: { name: 'Second Wind', cooldown: 4, desc: 'Patch up for 30% max HP and shrug off the next hit — no retaliation.' },
  ARCHER: { name: 'Aimed Shot', cooldown: 3, desc: 'A cold, armor-piercing kill-shot — ×2.0 damage, ignores defense.' },
  MAGE: { name: 'Dirty Trick', cooldown: 3, desc: 'Cut them — bleeding for 6% max HP a round, 2 rounds.' },
};

/** Universal mob-fight moves every class shares, for the reference strip under
 *  the class ability card. Mirrors resolveRound()'s constants. */
export const UNIVERSAL_MOVES: { name: string; desc: string }[] = [
  { name: 'Strike', desc: 'Standard attack — 15% crit chance for ×1.8 damage.' },
  { name: 'Heavy', desc: '75% chance to hit for ×1.7 damage; on a miss it whiffs entirely. Incoming hits land harder (×1.4) that round.' },
  { name: 'Guard', desc: 'Your damage out is cut to ×0.6; damage taken is halved, with a 20% chance to block it outright.' },
];
